import AdminUsersRequests from '../../server/adminUsers';
import { addLoading, removeLoading } from './loading';

export const getAdminUsers = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    const adminUsers = await AdminUsersRequests.getAdminUsers();
    dispatch(dispatch({ type: 'GET_ADMIN_USERS', adminUsers }));
  } finally {
    dispatch(removeLoading());
  }
};

export const createUser = ({ name, email, password, profileId }) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await AdminUsersRequests.createAdminUser({ name, email, password, profileId });
  } finally {
    dispatch(removeLoading());
  }
};

export const updateAdminUser = (id, {
  name, email, password, status, profileId,
}) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await AdminUsersRequests.updateAdminUser(id, {
      name, email, password, status, profileId,
    });
  } finally {
    dispatch(removeLoading());
  }
};

export const toggleAdminUserStatus = (id, status) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await AdminUsersRequests.activeAdminUser(id, status);
  } finally {
    dispatch(getAdminUsers());
    dispatch(removeLoading());
  }
};

export const getCsvAdminUsersModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AdminUsersRequests.getCsvAdminUsersModel();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadAdministrators = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await AdminUsersRequests.uploadCsvAdminUsers(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
